import { Flex } from '@taxbit-private/cosmic'
import styled from 'styled-components'

import useAppStore from 'store/useAppStore'

import TimedToast from './TimedToast'

const ToastNotifications: React.FC = () => {
  const cosmicToasts = useAppStore((state) => state.cosmicToasts)

  /* Launch test toasts */
  return (
    <StyledFlex aria-live="polite" aria-atomic="true" direction="column" gap="s">
      {cosmicToasts.map((toast) => (
        <TimedToast key={toast.uuid} {...toast} />
      ))}
    </StyledFlex>
  )
}

const StyledFlex = styled(Flex)(
  ({ theme }) => `
  position: fixed;
  bottom: 0;
  right: 0;
  left: 50%;
  transform: translateX(-50%);
  width: ${theme.measure.xl};
  padding: ${theme.spacing.m};
  transition: all 0.3s ease-in-out;
  z-index: 99999;
`
)

export default ToastNotifications
